import Mutations from '../../odata/mutations';

export default { ...new Mutations('pallet'), ...new Mutations('pallets') };
